export const SAVE_APPOINTMENT_COMPLETE_STATUS = "SAVE_APPOINTMENT_COMPLETE_STATUS"
export const SAVE_APPOINTMENT_COMPLETE_STATUS_FAIL = "SAVE_APPOINTMENT_COMPLETE_STATUS_FAIL"
export const SAVE_APPOINTMENT_COMPLETE_STATUS_SUCCESS = "SAVE_APPOINTMENT_COMPLETE_STATUS_SUCCESS"
export const SAVE_APPOINTMENT_COMPLETE_STATUS_RESET = "SAVE_APPOINTMENT_COMPLETE_STATUS_RESET"

export const saveAppointmentCompleteStatus = (params) => {
    return { type: SAVE_APPOINTMENT_COMPLETE_STATUS, params }
}
export const saveAppointmentCompleteStatusFail = (response) => {
    return { type: SAVE_APPOINTMENT_COMPLETE_STATUS_FAIL, response }
}
export const saveAppointmentCompleteStatusSuccess = (response) => {
    return { type: SAVE_APPOINTMENT_COMPLETE_STATUS_SUCCESS, response }
}
export const saveAppointmentCompleteStatusReset = () => {
    return { type: SAVE_APPOINTMENT_COMPLETE_STATUS_RESET }
}